<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.custStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.custStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              openEditPage({
                pageType: 'detail',
                params: row
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              openEditPage({
                pageType: 'edit',
                params: row
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="row.custStatus != 'N'"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="del(row.supCode)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
//import tableColumns from './table-columns'

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    components: {}
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      //tableColumns: tableColumns()
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'supNo',
          align: 'left',
          minWidth: 140,
          title: this.$l('table_label_sup_no') || '厂家编码',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'supName',
          align: 'left',
          minWidth: 140,
          title: this.$l('table_label_sup_name') || '厂家名称',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },

        {
          field: 'contact',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_contact') || '主要联系人',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'contactMobile',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_contact_mobile') || '联系人手机',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'contactPhone',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_contact_phone') || '固定电话',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'contactEmail',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_contact_email') || '联系人Email',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'contactJob',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_contact_job') || '联系人职务',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'supAddress',
          align: 'left',
          minWidth: 200,
          title: this.$l('table_label_sup_address') || '详细地址',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'custStatus',
          align: 'center',
          width: 100,
          title: this.$l('table_label_status') || '有效状态',
          slots: { default: 'status' },
          filters: [
            { label: '有效', value: 'Y' },
            { label: '无效', value: 'N' }
          ],
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'createBy',
          align: 'left',
          minWidth: 110,
          title: this.$l('table_label_create_by') || '创建人',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'createDate',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_create_date') || '创建时间',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'modifyBy',
          align: 'left',
          minWidth: 110,
          title: this.$l('table_label_modify_by') || '修改人',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'modifyDate',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_modify_date') || '修改时间',
          sortable: true,
          sortType: 'string',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.masSupplierDelApi({ supCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'master-supplierSet-detail',
        params: { ...params, pageType }
      })
    }
  }
}
</script>
